<span class="stock-summary">
  @if (packaged || semantics === 'basket') {
    <span class="stock-summary__jar" [class.stock-summary__jar--unknown]="percent === null" aria-hidden="true">
      <span [style.height.%]="percent ?? 0"></span>
    </span>
    <span class="stock-summary__copy">
      @if (packagingQuantity !== null && packagingQuantity !== undefined) {
        <span class="stock-summary__pack">{{ quantity | smNumber }} {{ stockUnitLabel }} × {{ packagingQuantity | smNumber }} {{ unitLabel }}</span>
      }
      <span>{{ (semantics === 'basket' ? 'stockSummary.stock' : 'stockSummary.remaining') | translate }}:
        @if (splitRemaining; as parts) {
          @if (parts.full > 0 || parts.extra === 0) { <strong>{{ parts.full | smNumber }}</strong> {{ stockUnitLabel }} }
          @if (parts.full > 0 && parts.extra > 0) { + }
          @if (parts.extra > 0) { <strong>{{ parts.extra | smNumber }}</strong> {{ unitLabel }} }
        } @else if (available !== null) {
          <strong>{{ available | smNumber:(semantics === 'basket' ? 6 : 3) }}</strong>
          @if (capacity !== null && capacity > 0) { {{ 'stockSummary.of' | translate }} {{ capacity | smNumber:(semantics === 'basket' ? 6 : 3) }} }
          {{ semantics === 'basket' ? stockUnitLabel : unitLabel }}
        } @else { {{ 'stockSummary.unknown' | translate }} }
        @if (percent !== null && capacity) { <span class="stock-summary__percent">({{ percent | smNumber:1 }}%)</span> }
      </span>
    </span>
  } @else if ((quantity !== null && quantity !== undefined)) {
    <span>{{ quantity | smNumber }} {{ stockUnitLabel }}</span>
  }
</span>
